export default __webpack_public_path__ + "static/media/With_Heatmap.11013582.jpg";